import api from 'src/request/http';
/*
* 菜单数据 返回Promise各式，支持前端硬编码、异步获取菜单数据
* */
export default function getMenus(userId) {
    return api.get('/menu/list').then(({success, data}) => {
        return (data  || []).map(item => ({key: item.id, parentKey: item.parentId, ...item}));
    });

    // // TODO 根据userId获取菜单数据 或在此文件中前端硬编码菜单
    // return Promise.resolve([

    //     { key: 'welcome', text: '场所预警', icon: 'home', path: '/', order: 10000 },

    //     { key: 'useRate', text: '使用率分析', icon: 'ant-design', path: '/merchant/use-rate/list', target: '', order: 9006 },

    //     { key: 'deviceManager', text: '设备管理', icon: 'DesktopOutlined', order: 8000 },
    //     { key: 'deviceWriteStore', parentKey: 'deviceManager', text: '设备入库', icon: 'align-left', path: '/device/write', order: 8009 },
    //     { key: 'devcieBind', parentKey: 'deviceManager', text: '设备绑定', icon: 'align-left', path: '/device/bind', order: 8008 },
    //     { key: 'devcieUnBind', parentKey: 'deviceManager', text: '解除场所绑定', icon: 'align-left', path: '/device/unbind', order: 8007 },
    //     { key: 'devcieQuery', parentKey: 'deviceManager', text: '铺设统计', icon: 'align-left', path: '/device/query', order: 8006 },
    //     { key: 'devcieBack', parentKey: 'deviceManager', text: '退回列表', icon: 'align-left', path: '/device/back', order: 8006 },


    //     { key: 'placeManager', text: '场所管理', icon: 'WindowsOutlined', order: 7000 },
    //     { key: 'placeList', parentKey: 'placeManager', text: '场所列表', icon: 'align-left', path: '/place/manager', order: 7009 },
    //     { key: 'channelList', parentKey: 'placeManager', text: '代理列表', icon: 'align-left', path: '/place/channel', order: 7008 },
    //     { key: 'Sharing', parentKey: 'placeManager', text: '分成方案', icon: 'align-left', path: '/place/share', order: 7007 },
    //     { key: 'priceScheme', parentKey: 'placeManager', text: '价格方案', icon: 'align-left', path: '/device/price', order: 7006 },
    //     { key: 'priceBuiltIn', parentKey: 'placeManager', text: '预设价格方案', icon: 'align-left', path: '/device/price/builtIn', order: 7006 },

    //     { key: 'financialManager', text: '财务管理', icon: 'AreaChartOutlined', order: 6000 },
    //     { key: 'cashManager', parentKey: 'financialManager', text: '提现管理',path:'/financial/manager', icon: 'align-left',order: 6009 },
    //     { key: 'cashExamine', parentKey: 'financialManager', text: '提现审核', path: '/financial/cash/examine', icon: 'align-left',order: 6008 },
    //     { key: 'autoCash', parentKey: 'financialManager', text: '自动提现', path: '/financial/auto/cash', icon: 'align-left',order: 6007 },

    //     { key: 'orderManager', text: '订单管理', icon: 'AreaChartOutlined', order: 5000 },
    //     { key: 'orderList', parentKey: 'orderManager', text: '订单列表',path:'/order/manager', icon: 'align-left',order: 5009 },
    //     { key: 'orderStatistics', parentKey: 'orderManager', text: '数据统计', path: '/order/statistics', icon: 'align-left',order: 5008 },

    //     { key: 'system', text: '系统管理', icon: 'SettingOutlined', order: 4000 },
    //     { key: 'user', parentKey: 'system', text: '用户管理', icon: 'align-left', path: '/system/user', order: 4009 },
    //     { key: 'role', parentKey: 'system', text: '角色管理', icon: 'lock', path: '/system/roles', order: 4008 },
    //     { key: 'menu', parentKey: 'system', text: '菜单管理', icon: 'align-left', path: '/system/menus', order: 4007 },
    //     { key: 'optimize', parentKey: 'system', text: '订单优化', icon: 'align-left',path: '/system/optimize', order: 4006 },
    //     { key: 'log-histroy', parentKey: 'system', text: '操作日志', icon: 'align-left', path: '/system/logs', order: 4003 },
    // ]);
}
/*
菜单数据主键也可以是：id parentId
角色字段： id name description
* */
